import { useEffect, useState } from "react";
import { PDFDownloadLink, Document, Page, Text, View, StyleSheet, PDFViewer } from '@react-pdf/renderer';
import { Link, useLoaderData, useParams } from "react-router-dom";
import { DocumentacionCreate } from "./DocumentacionCreate";

import { CertInfTratField } from "../components/documentacion/CertInfTrat";
import { ConInfAlcConSegField } from "../components/documentacion/ConInfAlcConSeg";
import { ConInfAlcSinSegField } from "../components/documentacion/ConInfAlcSinSeg";
import { ConInfBenzConSegField } from "../components/documentacion/ConInfBenzConSeg";
import { ConInfBenzSinSegField } from "../components/documentacion/ConInfBenzSinSeg";
import { ConInfCocConSegField } from "../components/documentacion/ConInfCocConSeg";
import { ConInfCocSinSegField } from "../components/documentacion/ConInfCocSinSeg";
import { ConInfHachConSegField } from "../components/documentacion/ConInfHachConSeg";
import { ConInfHachSinSegField } from "../components/documentacion/ConInfHachSinSeg";
import { ConInfHerConSegField } from "../components/documentacion/ConInfHerConSeg";
import { ConInfHerSinSegField } from "../components/documentacion/ConInfHerSinSeg";
import { ConInfMetConSegField } from "../components/documentacion/ConInfMetConSeg";
import { ConInfMetSinSegField } from "../components/documentacion/ConInfMetSinSeg";
import { FactTratField } from "../components/documentacion/FactTrat";
import { InfAltaField } from "../components/documentacion/InfAlta";
import { InfValPautDecField } from "../components/documentacion/InfValPautDec";
import { VolPetAnalField } from "../components/documentacion/VolPetAnal";
import { VolPetCovField } from "../components/documentacion/VolPetCov";
import { CuestSaludField } from "../components/documentacion/CuestSalud";
import { OtrosDocField } from "../components/documentacion/OtrosDoc";

import * as API from "../services/documentacion";


export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getDocumentacionByID(params.documentacionId);
}


export function DocumentacionItem(props) {
  const documentacion = useLoaderData();

  const docTitulo = documentacion.meta?.docTitulo;
  const docData = documentacion.meta?.docData;
  const docFileLink = documentacion.meta?.docFileLink;
  const [docBlobUrl, setDocBlobUrl] = useState('');

  const docDate = new Date(documentacion.date);
  const diffDate = Math.abs(new Date() - docDate) / 36e5;

  const obtenerBlobUrl = async () => {
    try {
      const response = await fetch('https://tu-servidor.com/ruta-al-documento');
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      setDocBlobUrl(blobUrl);
    } catch (error) {
      console.error('Error al obtener el blob URL:', error);
    }
  };

  const updateData = data => {}

  const docFieldComponent = () => {
    switch (docTitulo) {
      case "CertInfTrat":
        return <CertInfTratField updateData={updateData} savedData={docData} />;
      case "ConInfAlcConSeg":
        return <ConInfAlcConSegField updateData={updateData} savedData={docData} />;
      case "ConInfAlcSinSeg":
        return <ConInfAlcSinSegField updateData={updateData} savedData={docData} />;
      case "ConInfBenzConSeg":
        return <ConInfBenzConSegField updateData={updateData} savedData={docData} />;
      case "ConInfBenzSinSeg":
        return <ConInfBenzSinSegField updateData={updateData} savedData={docData} />;
      case "ConInfCocConSeg":
        return <ConInfCocConSegField updateData={updateData} savedData={docData} />;
      case "ConInfCocSinSeg":
        return <ConInfCocSinSegField updateData={updateData} savedData={docData} />;
      case "ConInfHachConSeg":
        return <ConInfHachConSegField updateData={updateData} savedData={docData} />;
      case "ConInfHachSinSeg":
        return <ConInfHachSinSegField updateData={updateData} savedData={docData} />;
      case "ConInfHerConSeg":
        return <ConInfHerConSegField updateData={updateData} savedData={docData} />;
      case "ConInfHerSinSeg":
        return <ConInfHerSinSegField updateData={updateData} savedData={docData} />;
      case "ConInfMetConSeg":
        return <ConInfMetConSegField updateData={updateData} savedData={docData} />;
      case "ConInfMetSinSeg":
        return <ConInfMetSinSegField updateData={updateData} savedData={docData} />;
      case "FactTrat":
        return <FactTratField updateData={updateData} savedData={docData} />;
      case "InfAlta":
        return <InfAltaField updateData={updateData} savedData={docData} />;
      case "InfValPautDec":
        return <InfValPautDecField updateData={updateData} savedData={docData} />;
      case "VolPetAnal":
        return <VolPetAnalField updateData={updateData} savedData={docData} />;
      case "VolPetCov":
        return <VolPetCovField updateData={updateData} savedData={docData} />;
      case "CuestSalud":
        return <CuestSaludField updateData={updateData} savedData={docData} />;
        case "OtrosDoc":
        return <OtrosDocField updateData={updateData} savedData={docData} />;  
      default:
        return "";
    }
  };

  return (
    <>
    <div id="content">
      {documentacion.length === 0 ? (
        <div>Cargando...</div>
      ) : (
      <form id="formUpdatelement">
        <fieldset id="disabledContainer" disabled="disabled">

        <div className='field'>
              <label htmlFor='docTitulo'>Documentación</label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='docTitulo'
                    name='docTitulo'
                    readOnly
                    value={docTitulo}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='CertInfTrat'>Certificado Informe del Tratamiento</option>
                    <option value='ConInfAlcConSeg'>Consentimiento Informado Alcohol</option>
                    <option value='ConInfAlcSinSeg'>Consentimiento Informado Alcohol Sin Seguimiento</option>
                    <option value='ConInfBenzConSeg'>Consentimiento Informado Benzodiacepinas Con Seguimiento</option>
                    <option value='ConInfBenzSinSeg'>Consentimiento Informado Benzodiacepinas Sin Seguimiento</option>
                    <option value='ConInfCocConSeg'>Consentimiento Informado Cocaina Con Seguimiento</option>
                    <option value='ConInfCocSinSeg'>Consentimiento Informado Cocaina Sin Seguimiento</option>
                    <option value='ConInfHachConSeg'>Consentimiento Informado Hachis Con Seguimiento</option>
                    <option value='ConInfHachSinSeg'>Consentimiento Informado Hachis Sin Seguimiento</option>
                    <option value='ConInfHerConSeg'>Consentimiento Informado Heroina Con Seguimiento</option>
                    <option value='ConInfHerSinSeg'>Consentimiento Informado Heroina Sin Seguimiento</option>
                    <option value='ConInfMetConSeg'>Consentimiento Informado Metadona Con Seguimiento</option>
                    <option value='ConInfMetSinSeg'>Consentimiento Informado Metadona Sin Seguimiento</option>
                    <option value='FactTrat'>Factura Tratamiento</option>
                    <option value='InfAlta'>Informe de Alta</option>
                    <option value='InfValPautDec'>Informe Valoracion con Pauta Decalaje</option>
                    <option value='VolPetAnal'>Volante Peticion Analitica</option>
                    <option value='VolPetCov'>Volante Test COVID</option>
                    <option value='CuestSalud'>Cuestionario de Salud</option>
                    <option value='OtrosDoc'>Otros Documentos</option>
                  </select>
                </div>
              </div>
            </div>
      </fieldset>
      <div className="pdf-upload">
          <h3>Documento firmado</h3>
          {docFileLink ? (
            <a className="button is-link" href={`${docFileLink}`} download>Descargar documento firmado</a>
            ) : (
              <p>Documento sin firmar</p>
          )}
        </div>
      </form>
      )}
    </div>
    <div id="actions">
      {(diffDate <= 72 || props.userRole.includes('administrador')) && (
        <Link className="button is-link" to={`edit`}>Editar</Link>
      )}
      
    </div>
    </>
  );
}
